import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import renderViewsState from '../shared/render-views-state';

import _get from 'lodash/get';

import SingleBonus from './components/single-bonus';

lessRequire('modules/discounts/main.less');

const Main = renderViewsState(props => {
	const { intl, data, user } = props;
	if (_get(user, 'general.language') && !['ru', 'en'].includes(user.general.language)) {
		browserHistory.push('/404');
	}
	return (
		<div className="dashboard container container__with-columns">

			<div className="discounts font-proxima-nova-regular">
				<div className="container__content">
					<div className="container__content-title">
						<h2 className="font-proxima-nova-bold">
							{intl('Бонусные программы')}
						</h2>
					</div>
					<div className="container__content-subtitle font-proxima-nova-bold">
						{intl('ЛОВИ ПРИЯТНЫЕ УСЛОВИЯ ИСПОЛЬЗОВАНИЯ ПОЛЕЗНЫХ СЕРВИСОВ')}
					</div>
					<div className="container__content-table">
						{
							data.map((bonus, index) => (
								<SingleBonus intl={intl} key={index} {...bonus} />
							))
						}

					</div>
				</div>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		user: selectors.getUserData(state),
		manager: selectors.getManager(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/discounts/main.js